export default {
  answerButton: 'Répondre',
  breadCrumbMessages: 'Mes messages',
  deleteMessage: 'Supprimer le message',
  title: "Détail d'un courriel",
  object: 'Objet :',
  lob: "Secteur d'activité :",
  contract: 'Contrat :',
  recipient: 'Destinataire :',
  anotherRecipient: 'Autre destinataire :',
  receivedDate: 'Reçu :',
  expirationDate: 'Date d\'expiration :',
  sentDate: 'Envoyé :',
  number: 'No.',
  buttonDelete: 'Supprimer le message',
  messageDeleteSnackbar: 'Message supprimé.',
  cancelButton: 'Annuler',
  sendAnswerButton: 'Envoyer',
  messageAnswerSnackbar: 'Réponse envoyée ({{msgId}})',
};
